import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Radicacion, RadicadoCita, Const } from "@app/shared";
import { HttpErrorHandlingService, EndpointService } from "@app/core";
import { environment } from "@env/environment";

export interface GenerateRadication {
  clasificacion_documentos: number;
  documento_cita: string;
  fecha: Date;
  folios: number;
  id: number;
  id_documento_cita: number;
  radicado: string;
  id_dependencia: number;
  tipo_documental?: number | string;
}

export interface Sticker {
  id?: number;
  nombre?: string;
  tipo_documental?: TipoDocumental;
}

export interface TipoDocumental {
  id: number;
  nombre: string;
  codigo: string;
  expediente: boolean;
  subserie: number;
}

export interface Responsable {
  id: number;
  first_name: string;
  last_name: string;
}

export interface DocumentAnnulation {
  id?: number;
  tramite: number;
  documento: number;
  motivo: string;
  fecha: Date;
  responsable?: Responsable;
}

@Injectable()
export class AnnulationProcessDataService{
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private hehs: HttpErrorHandlingService,
    private api: EndpointService
  ) {}

  
  /**
   *Anular trámite
   *
   * @param {number} id_process
   * @param {string} annulation
   * @param {string} reason
   * @return {*}  {Observable<any>}
   * @memberof AnnulationProcessDataService
   */
  annulation(id_process: number, annulation: string, reason: string): Observable<any>{
    let formData = {
      id_tramite: id_process,
      anulacion: annulation,
      motivo: reason
    }
    return new Observable((obs) => {
      this.http
        .post(this.api.get("annul"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 201 || res.status === 200) {
              obs.next(res.body);
              this.toastr.success("Trámite anulado correctamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/annulation-process/shared/annulation-process.data.service.ts